// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3NpEF","loaderOuter":"PageOverlayLoader_loaderOuter__3_Jmd"};